import K from '../constants/MenuConstants';

export function hideTopMenu() {
    return {
        type: K.MENU_TOP_HIDE
    };
}

export function showTopMenu() {
    return {
        type: K.MENU_TOP_SHOW
    };
}

export function hideLeftMenu() {
    return {
        type: K.MENU_LEFT_HIDE
    };
}

export function showLeftMenu() {
    return {
        type: K.MENU_LEFT_SHOW
    };
}

export function hideTailormadeMenu() {
    return {
        type: K.MENU_TAILORMADE_HIDE
    };
}

export function showTailormadeMenu() {
    return {
        type: K.MENU_TAILORMADE_SHOW
    };
}

export function hideBridesMenu() {
    return {
        type: K.MENU_BRIDES_HIDE
    };
}

export function showBridesMenu() {
    return {
        type: K.MENU_BRIDES_SHOW
    };
}

export function hideBSMenu() {
    return {
        type: K.MENU_BS_HIDE
    };
}

export function showBSMenu() {
    return {
        type: K.MENU_BS_SHOW
    };
}

// Hide All
export function hideAllMenus() {
    return dispatch => {
        dispatch(hideTopMenu());
        dispatch(hideLeftMenu());
        dispatch(hideTailormadeMenu());
        dispatch(hideBridesMenu());
        dispatch(hideBSMenu());
        return Promise.resolve();
    };
}



// WEBPACK FOOTER //
// ./src/actions/MenuActions.js